<template>
  <div>
    <div class="con-vs-alert con-vs-alert-danger mb-4">
      <div class="vs-alert text-center" v-if="dispositivo.apkversion.indexOf('4.') === 0"> {{ $t('TxtVip') }}</div>
      <div class="vs-alert text-center" v-else> {{ $t('TxtClientVip') }}.</div>
    </div>

    <div class="text-center">
      <a :href="`/planos/mobile/${dispositivo.uid}/1`" rel="noopener">
        <button name="button" class="vs-component vs-button vs-button-warning vs-button-relief mt-3 mr-2">
          <span class="vs-button-text vs-button--text"> <i class="fas fa-mobile"></i> {{ $t('SeePlans') }}</span>
          <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%)"></span>
        </button>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appName: process.env.VUE_APP_NAME,
      dispositivo: {}
    }
  },
  mounted() {
    this.dispositivo = JSON.parse(this.$localStorage.get('mobile'))
  }
}
</script>
